import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-page07',
  templateUrl: './blog-page07.component.html',
  styleUrls: ['./blog-page07.component.css']
})
export class BlogPage07Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
